'use client';

import { __resetStyles, mergeClasses } from "@griffel/react";
import { tokens } from "@fluentui/react-theme";
export const breadcrumbItemClassNames = {
  root: 'fui-BreadcrumbItem'
};
const useBreadcrumbItemResetStyles = /*#__PURE__*/__resetStyles("r1tl60rs", null, [".r1tl60rs{display:flex;align-items:center;color:var(--colorNeutralForeground2);box-sizing:border-box;text-wrap:nowrap;}"]);
/**
 * Apply styling to the BreadcrumbItem slots based on the state
 */
export const useBreadcrumbItemStyles_unstable = state => {
  const resetStyles = useBreadcrumbItemResetStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(breadcrumbItemClassNames.root, resetStyles, state.root.className);
  return state;
};